var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Entschuldigung, aber die gewünschte Seite wurde nicht gefunden."),_c('br'),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Hier geht es zu meinen Büchern")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }